import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  const featured = articles.find((a) => a.featured) ?? articles[0];
  const secondary = articles.filter((a) => a.id !== featured.id).slice(0, 3);

  const stats = [
    { value: '1,200+', label: '累计独家线索' },
    { value: '5', label: '覆盖栏目' },
    { value: '每日 3 次', label: '更新频率' },
  ];

  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5 flex flex-col justify-center">
            <span className="inline-flex w-fit items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse-dot"></span>
              独家首发 · 持续更新
            </span>
            <h1 className="font-heading font-bold text-4xl md:text-5xl leading-tight text-foreground-950">
              {siteConfig.name}
            </h1>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed max-w-lg">
              聚焦未公开信息与内部消息，汇集知情人士爆料与第一手料整理。用时间线还原事件脉络，让你看到别处没有的细节。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to={`/article/${featured.id}`}
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                阅读本期独家
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line"></i>
                提交线索
              </Link>
            </div>
            <dl className="mt-9 grid grid-cols-3 gap-4 max-w-md border-t border-background-200 pt-6">
              {stats.map((s) => (
                <div key={s.label}>
                  <dt className="font-heading font-bold text-xl text-foreground-950">{s.value}</dt>
                  <dd className="mt-1 text-xs text-foreground-500">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-7">
            <Link
              to={`/article/${featured.id}`}
              className="group relative block w-full h-[300px] md:h-[380px] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={featured.cover}
                alt={`${featured.title} - 17爆料网独家首发配图`}
                title={`${featured.title} - 17爆料网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-1 rounded bg-accent-600 text-background-50 text-xs font-medium">独家</span>
                  <span className="px-2.5 py-1 rounded bg-background-50/20 text-background-50 text-xs backdrop-blur">
                    {featured.categoryName}
                  </span>
                  <span className="text-xs text-background-200">{featured.date}</span>
                </div>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-background-50 leading-snug">
                  {featured.title}
                </h2>
                <p className="mt-2 text-sm text-background-200 line-clamp-2 max-w-2xl">{featured.excerpt}</p>
              </div>
            </Link>

            <div className="mt-5 grid sm:grid-cols-3 gap-4">
              {secondary.map((a) => (
                <Link
                  key={a.id}
                  to={`/article/${a.id}`}
                  className="group block p-4 rounded-lg border border-background-200 bg-background-100 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <span className="text-xs text-primary-700 font-medium">{a.categoryName}</span>
                  <h3 className="mt-2 font-heading font-bold text-sm text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {a.title}
                  </h3>
                  <span className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-time-line"></i>
                    {a.date}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}